<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.payments.retrieveLoader" transition="fade-transition" type="table"/>
       <template v-else>
        <v-col v-if="!paymentsList.length" class="text-center py-5">
          <v-icon class="d-block" color="secondary" size="70">mdi-credit-card</v-icon>
          <span class="d-block subtitle-1">No existen pagos</span>
        </v-col>
        <template v-else>
          <v-data-table :headers="headers" :items="paymentsList" :items-per-page="pagination" hide-default-header disable-sort mobile-breakpoint hide-default-footer @click:row="(paymentsList) => {$router.push({name: 'PaymentRetrieve', params: {id: paymentsList.id}})}" style="cursor: pointer">
            <!-- header -->
            <template v-slot:[`header`]="{ props: { headers } }">
              <VTableHeaders :headers="headers" @sort="setSort" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.customer`]="{item}">
              <router-link :to="{name: 'CustomerRetrieveUpdate', params: {id: item.customer.id}}" v-if="item.customer" class="primary--text routerLink font-weight-medium">{{item.customer.name}}</router-link>
              <span class="font-italic text--disabled" v-else>Cliente no especificado</span>
            </template>
            <template v-slot:[`item.status`]="{item}">
              <div class="text-right">
                <v-chip v-if="item.status === 'succeeded'" color="lightBlue" small text-color="primary">Pagado<v-icon class="mx-1" x-small>mdi-check</v-icon></v-chip>
                <v-chip v-else-if="item.status === 'requires_payment_method'" color="defaultGrey" small text-color="secondary">Pendiente</v-chip>
                <v-chip v-else-if="item.status === 'failed'" color="defaultGrey" small text-color="secondary">Fallido</v-chip>
                <v-chip v-else-if="item.status === 'cancelled'" color="defaultGrey" small text-color="secondary">Cancelado<v-icon class="mx-1" x-small>mdi-close</v-icon></v-chip>
                <v-chip v-else-if="item.status === 'processing'" color="defaultGrey" small text-color="secondary">Procesando</v-chip>
                <v-chip v-else-if="item.status === 'incomplete'" color="defaultGrey" small text-color="secondary">Incompleto</v-chip>
              </div>
            </template>
            <template v-slot:[`item.date`]="{item}">
              <span>{{item.date | date}}</span>
            </template>
            <template v-slot:[`item.payment_date`]="{item}">
              <span v-if="item.payment_date">{{item.payment_date | dateTime}}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:[`item.balance`]="{item}">
              <span class="text--secondary font-weight-medium">{{item.balance | currency(item.currency)}}</span> {{item.currency}}
            </template>
            <template v-slot:[`item.amount`]="{item}">
              <span class="text--secondary font-weight-medium">{{item.amount | currency(item.currency)}}</span> {{item.currency}}
            </template>
          </v-data-table>
          <template v-if="showPagination || showAll">
            <v-divider />
            <v-row class="mx-0" align="center">
              <v-col cols="12" class="text-center" v-if="showAll">
                <v-btn :to="{name: 'PaymentListCreate', query: showCriteria}" outlined color="secondary">Ver todos los pagos</v-btn>
              </v-col>
              <template v-if="showPagination">
                <v-col cols="6">
                  <span class="body-2 text--secondary">{{count}} registros</span>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                </v-col>
              </template>
            </v-row>
          </template>
        </template>
       </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'

const headers = [
  { text: 'Cliente', value: 'customer', sortable: true },
  { value: 'status' },
  { text: 'Descripción', value: 'description' },
  { text: 'Vencimiento', value: 'date', width: 160, align: 'end', sortable: true },
  { text: 'Fecha de pago', value: 'payment_date', width: 160, align: 'end', sortable: true },
  { text: 'Pendiente', value: 'balance', width: 160, align: 'end', sortable: true },
  { text: 'Monto', value: 'amount', width: 160, align: 'end', sortable: true }
]

export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    baseHeaders: headers,
    headers: headers
  }),
  computed: mapState({
    count: state => state.payments.paymentsCount,
    paymentsList: state => state.payments.paymentsList,
    toggleHeaders: state => state.ui.paymentsToggleHeaders
  })
}
</script>